<div id="wrapper">
    <app-navbar></app-navbar>

    <app-sidebar [isCondensed]="isCondensed"></app-sidebar>

    <div class="content-page">
        <div class="content">
            <div class="content-pane">
                <div class="container-fluid">
                    <div class="breadcrumb">
                        <span class="breadcrumb-item">
                            <a href="javascript:void(0)">PayEXAP</a>
                        </span>
                        <span class="px-2"
                            ><i class="ri-arrow-right-s-line"></i
                        ></span>
                        <span class="breadcrumb-item" aria-current="page">
                            <a routerLink="/manage-queries">Queries</a>
                        </span>
                    </div>

                    <div class="row negative-margin">
                        <div class="col-md-12">
                            <div
                                *ngIf="sessionExpired"
                                class="alert alert-danger session-text text-center"
                                role="alert"
                            >
                                {{ errorMsg }}
                                <span class="relogin" (click)="accountLogout()"
                                    >Click here to LogIn</span
                                >
                            </div>
                            <div
                                *ngIf="vendorError && queryError"
                                class="alert alert-danger session-text text-center"
                                role="alert"
                            >
                                {{ errorMsg }}
                                <span class="relogin" (click)="accountLogout()"
                                    >Click here to LogIn</span
                                >
                            </div>

                            <!-- Status Update Progress Bar -->
                            <div *ngIf="statusUpdateProgress.isVisible" class="alert alert-info d-flex align-items-center mt-2">
                                <i class="ri-refresh-line me-2" style="animation: spin 1s linear infinite;"></i>
                                <div class="flex-grow-1">
                                    <div class="d-flex justify-content-between align-items-center mb-1">
                                        <span>Updating query status....</span>
                                        <span>{{ statusUpdateProgress.current }} / {{ statusUpdateProgress.total }}</span>
                                    </div>
                                    <div class="progress" style="height: 6px;">
                                        <div class="progress-bar bg-info" 
                                             [style.width.%]="(statusUpdateProgress.current / statusUpdateProgress.total) * 100">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card manage-invoice">
                                <div class="card-body">
                                    <div class="pane-header mb-3">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <h4 class="mt-2">
                                                    Manage Queries
                                                </h4>
                                            </div>
                                            <div class="col-md-6">
                                                <div
                                                    class="actions-pane float-end mt-2"
                                                >
                                                    <div class="notification-container d-inline-block position-relative">
                                                        <button
                                                            (click)="toggleNotificationPanel()"
                                                            class="btn btn-outline-primary position-relative"
                                                            type="button"
                                                            title="Notifications"
                                                        >
                                                            <i class="ri-notification-3-line"></i>
                                                            <span 
                                                                *ngIf="unreadNotificationCount > 0"
                                                                class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-bell"
                                                            >
                                                                {{ unreadNotificationCount > 9 ? '9+' : unreadNotificationCount }}
                                                            </span>
                                                        </button>
                                                        
                                                        <div 
                                                            *ngIf="showNotificationPanel"
                                                            class="notification-panel position-absolute top-100 end-0 mt-1 bg-white border rounded shadow-lg"
                                                            style="width: 350px; max-height: 400px; overflow-y: auto; z-index: 1000;"
                                                        >
                                                            <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
                                                                <h6>Clarification Required</h6>
                                                                <button 
                                                                    (click)="clearAllNotifications()"
                                                                    class="btn btn-sm btn-outline-danger"
                                                                    title="Clear all notifications"
                                                                >
                                                                    <i class="ri-delete-bin-line"></i>
                                                                </button>
                                                            </div>
                                                            
                                                            <div *ngIf="clarificationNotifications.length === 0" 
                                                                class="p-3 text-center border rounded small" 
                                                                style="background-color: #f8fdf9;">
                                                            <i class="ri-check-line" style="font-size: 30px; display: block; margin-bottom: 6px;"></i>
                                                            <p class="mb-0 fw-semibold" style="font-size: 16px;">No clarification required</p>
                                                            </div>
                                                            
                                                            <div *ngFor="let notification of clarificationNotifications" class="p-3 border-bottom">
                                                                <div class="d-flex justify-content-between align-items-start">
                                                                    <div class="flex-grow-1" (click)="onNotificationClick(notification)" style="cursor: pointer;">
                                                                        <div class="d-flex align-items-center mb-1">
                                                                            <a href="javascript:void(0)"><strong>{{ notification.queryId }}</strong></a>
                                                                        </div>
                                                                        <p class="mb-0">{{ notification.message }}</p>
                                                                    </div>
                                                                    <button 
                                                                        (click)="markNotificationAsRead(notification)"
                                                                        class="btn btn-sm btn-outline-secondary ms-2"
                                                                        title="Mark as read"
                                                                        *ngIf="!notification.isRead"
                                                                    >
                                                                        <i class="ri-check-line"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <button
                                                        (click)="manualRefreshStatuses()"
                                                        class="btn btn-outline-primary me-2"
                                                        type="button"
                                                        [disabled]="isStatusUpdateRunning"
                                                    >
                                                        <i class="ri-refresh-line me-1"></i>
                                                        <span *ngIf="!isStatusUpdateRunning">Refresh Status</span>
                                                        <span *ngIf="isStatusUpdateRunning">Updating...</span>
                                                    </button>
                                                    

                                                    <button
                                                        (click)="submitQuery()"
                                                        class="btn btn-invoice mr-2"
                                                        type="button"
                                                    >
                                                        Submit Query
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="search-pane">
                                        <div class="row">
                                            <div class="col-md-2 col-sm-4">
                                                <label
                                                    class="d-inline-flex align-items-center mb-3"
                                                >
                                                    <select
                                                        id="show-headers"
                                                        class="form-select form-select-sm mx-1"
                                                        (change)="
                                                            onFilter($event)
                                                        "
                                                    >
                                                        <option
                                                            disabled selected hidden
                                                        >
                                                            Select
                                                        </option>
                                                        <option
                                                            value="queryId"
                                                        >
                                                            Query ID
                                                        </option>

                                                        <option
                                                            value="eDeskTicketNo"
                                                        >
                                                            E-Desk Ticket No.
                                                        </option>
                                                        <option value="category">
                                                            Query Category
                                                        </option>
                                                        <option value="status">
                                                            Query Status
                                                        </option>
                                                    </select>
                                                </label>
                                            </div>
                                            <div class="col-md-4 col-sm-8">
                                                <div
                                                    class="input-group flex-nowrap"
                                                >
                                                    <ng-container
                                                        *ngIf="selectedOption"
                                                    >
                                                        <input
                                                            type="text"
                                                            class="form-control highlighted"
                                                            placeholder="Enter search value"
                                                            aria-label="search"
                                                            aria-describedby="addon-wrapping"
                                                            (keyup)="
                                                                onSearch($event)
                                                            "
                                                        />
                                                        <span
                                                            class="input-group-text highlighted"
                                                            id="addon-wrapping"
                                                            ><i
                                                                class="ri-search-line"
                                                            ></i
                                                        ></span>
                                                        <button
                                                            *ngIf="searchTerm"
                                                            type="button"
                                                            class="btn btn-outline-secondary"
                                                            (click)="clearSearch()"
                                                            title="Clear search"
                                                        >
                                                            <i class="ri-close-line"></i>
                                                        </button>
                                                    </ng-container>
                                                    <ng-container
                                                        *ngIf="!selectedOption"
                                                    >
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Search..."
                                                            aria-label="search"
                                                            aria-describedby="addon-wrapping"
                                                            (keyup)="
                                                                generalSearch(
                                                                    $event
                                                                )
                                                            "
                                                        />
                                                        <span
                                                            class="input-group-text"
                                                            id="addon-wrapping"
                                                            ><i
                                                                class="ri-search-line"
                                                            ></i
                                                        ></span>
                                                        <button
                                                            *ngIf="searchTerm"
                                                            type="button"
                                                            class="btn btn-outline-secondary"
                                                            (click)="clearSearch()"
                                                            title="Clear search"
                                                        >
                                                            <i class="ri-close-line"></i>
                                                        </button>
                                                    </ng-container>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="download-pane float-end d-flex align-items-center gap-3">
                                                    <i
                                                        class="ri-refresh-line"
                                                        title="Refresh"
                                                        (click)="!loading && loadQueries()"
                                                        [style.opacity]="loading ? 0.45 : 1"
                                                        [style.pointer-events]="loading ? 'none' : 'auto'"
                                                    ></i>
                                                    <!-- <i
                                                        class="ri-file-download-line"
                                                        (click)="exportToExcel()"
                                                    ></i> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="table-responsive">
                                        <div
                                            class="loader text-center"
                                            *ngIf="loading || fetching"
                                        >
                                            <app-loader></app-loader>
                                        </div>

                                        <ng-container *ngIf="!loading">
                                            <div
                                                *ngIf="isEmpty"
                                                class="text-center py-5"
                                            >
                                                <img
                                                    src="assets/images/empty-state.png"
                                                    alt="No-data"
                                                />
                                                <h1 class="card-title my-2">
                                                    No Invoices Available
                                                </h1>
                                                <p class="card-text">
                                                    There is no available data
                                                    to show yet
                                                </p>
                                            </div>
                                            <ng-container *ngIf="!isEmpty">
                                                <table
                                                    aria-describedby="invoices-list"
                                                    class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint purchase-orders text-nowrap"
                                                    data-page-size="5"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                scope="col"
                                                                [appSort]="
                                                                    queries
                                                                "
                                                                data-order="desc"
                                                                data-name="queryId"
                                                                style="text-align: center !important"
                                                            >
                                                                Query ID
                                                                <span
                                                                    ><i
                                                                        class="bi bi-chevron-expand"
                                                                    ></i
                                                                ></span>
                                                            </th>

                                                            <th
                                                                scope="col"
                                                                [appSort]="
                                                                    queries
                                                                "
                                                                data-order="desc"
                                                                data-name="eDeskTicketNo"
                                                                style="text-align: center !important"
                                                            >
                                                                e-Desk Ticket No.
                                                                <span
                                                                    ><i
                                                                        class="bi bi-chevron-expand"
                                                                    ></i
                                                                ></span>
                                                            </th>

                                                            <th
                                                                scope="col"
                                                                [appSort]="
                                                                    queries
                                                                "
                                                                data-order="desc"
                                                                data-name="category"
                                                                style="text-align: center !important"
                                                            >
                                                                Query Category
                                                                <span
                                                                    ><i
                                                                        class="bi bi-chevron-expand"
                                                                    ></i
                                                                ></span>
                                                            </th>

                                                            <th
                                                            scope="col"
                                                            [appSort]="
                                                                queries
                                                            "
                                                            data-order="desc"
                                                            data-name="date"
                                                            style="text-align: center !important"
                                                        >
                                                            Query Date
                                                            <span
                                                                ><i
                                                                    class="bi bi-chevron-expand"
                                                                ></i
                                                            ></span>
                                                        </th>

                                                            <th
                                                                scope="col"
                                                                [appSort]="
                                                                    queries
                                                                "
                                                                data-order="desc"
                                                                data-name="status"
                                                                style="text-align: center !important"
                                                            >
                                                                Query Status
                                                                <span
                                                                    ><i
                                                                        class="bi bi-chevron-expand"
                                                                    ></i
                                                                ></span>
                                                            </th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <ng-container *ngFor="let query of queries">
                                                            <tr 
                                                                style="text-align: center;"
                                                                [ngClass]="{'clarification-required-row': query.status?.toLowerCase() === 'clarification required'}"
                                                            >
                                                                <td>
                                                                    <a href="javascript:void(0)" (click)="onQueryIdClick(query.queryId)">
                                                                        {{ query.queryId }}
                                                                    </a>
                                                                </td>

                                                                <td>
                                                                    {{
                                                                        query.eDeskTicketNo
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        query.category
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        query.crtDtTm
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    <div class="status-badge position-relative">
                                                                        <span 
                                                                            class="badge" 
                                                                            [ngClass]="getStatusBadgeClass(query.status)">
                                                                            {{ query.status }}
                                                                            
                                                                            <!-- Updating indicator -->
                                                                            <i *ngIf="isQueryUpdating(query.queryId)" 
                                                                               class="ri-loader-4-line ms-1" 
                                                                               style="font-size: 0.8em; animation: spin 1s linear infinite;"></i>
                                                                            
                                                                            <!-- Error indicator -->
                                                                            <i *ngIf="getQueryErrorCount(query.queryId) > 0" 
                                                                               class="ri-error-warning-line ms-1" 
                                                                               style="font-size: 0.8em; color: #dc3545;"
                                                                               [title]="'Failed to update ' + getQueryErrorCount(query.queryId) + ' times'"></i>
                                                                        </span>
                                                                        

                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </ng-container>
                                                    </tbody>
                                                </table>
                                            </ng-container>
                                        </ng-container>
                                        <div class="table-footer py-3">
                                            <div class="row">
                                                <div class="col-sm-5">
                                                    <label
                                                        class="d-inline-flex align-items-center mb-3"
                                                    >
                                                        Show
                                                        <select
                                                            id="demo-show-entries"
                                                            class="form-select form-select-sm mx-1"
                                                            [(ngModel)]="
                                                                pageSize
                                                            "
                                                            (ngModelChange)="
                                                                refreshQueries()
                                                            "
                                                        >
                                                            <option
                                                                [ngValue]="10"
                                                            >
                                                                10
                                                            </option>
                                                            <option
                                                                [ngValue]="25"
                                                            >
                                                                25
                                                            </option>
                                                            <option
                                                                [ngValue]="50"
                                                            >
                                                                50
                                                            </option>
                                                            <option
                                                                [ngValue]="100"
                                                            >
                                                                100
                                                            </option>
                                                        </select>
                                                        entries
                                                    </label>
                                                </div>
                                                <div class="col-sm-7">
                                                    <div class="text-end">
                                                        <!-- Showing 1-5 of 15 entries -->
                                                        <ngb-pagination
                                                            class="justify-content: flex-end !important;"
                                                            [collectionSize]="
                                                                collectionSize
                                                            "
                                                            [(page)]="page"
                                                            [pageSize]="
                                                                pageSize
                                                            "
                                                            [maxSize]="4"
                                                            [rotate]="true"
                                                            [ellipses]="false"
                                                            [boundaryLinks]="
                                                                true
                                                            "
                                                            (pageChange)="
                                                                refreshQueries()
                                                            "
                                                        >
                                                        </ngb-pagination>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
